import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withModifiers as _withModifiers, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, vShow as _vShow, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-20e15257"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header align-items-center border-0" }
const _hoisted_3 = { class: "card-title align-items-start flex-column" }
const _hoisted_4 = { class: "card-toolbar flex-row-fluid justify-content-end gap-5" }
const _hoisted_5 = { class: "svg-icon svg-icon-2" }
const _hoisted_6 = {
  key: 1,
  class: "btn btn-sm btn-primary",
  "data-bs-toggle": "modal",
  "data-bs-target": "#modal_inspection_steps"
}
const _hoisted_7 = { class: "svg-icon svg-icon-2" }
const _hoisted_8 = { class: "card-body pt-6" }
const _hoisted_9 = { class: "nav nav-pills nav-pills-custom mb-3" }
const _hoisted_10 = { class: "nav-item mb-3 me-3 me-lg-6" }
const _hoisted_11 = { class: "svg-icon svg-icon-2 mb-2" }
const _hoisted_12 = {
  key: 0,
  class: "bullet-custom position-absolute bottom-0 w-100 h-4px bg-primary"
}
const _hoisted_13 = { class: "nav-item mb-3 me-3 me-lg-6" }
const _hoisted_14 = { class: "svg-icon svg-icon-2 mb-2" }
const _hoisted_15 = { class: "fw-normal fs-7" }
const _hoisted_16 = {
  key: 0,
  class: "bullet-custom position-absolute bottom-0 w-100 h-4px bg-primary"
}
const _hoisted_17 = { class: "nav-item mb-3 me-3 me-lg-6" }
const _hoisted_18 = { class: "svg-icon svg-icon-2 mb-2" }
const _hoisted_19 = { class: "fw-normal fs-7" }
const _hoisted_20 = {
  key: 0,
  class: "bullet-custom position-absolute bottom-0 w-100 h-4px bg-primary"
}
const _hoisted_21 = { class: "nav-item mb-3 me-3 me-lg-6" }
const _hoisted_22 = { class: "svg-icon svg-icon-2 mb-2" }
const _hoisted_23 = { class: "fw-normal fs-7" }
const _hoisted_24 = {
  key: 0,
  class: "bullet-custom position-absolute bottom-0 w-100 h-4px bg-primary"
}
const _hoisted_25 = { class: "nav-item mb-3 me-3 me-lg-6" }
const _hoisted_26 = { class: "svg-icon svg-icon-2 mb-2" }
const _hoisted_27 = { class: "fw-normal fs-7" }
const _hoisted_28 = {
  key: 0,
  class: "bullet-custom position-absolute bottom-0 w-100 h-4px bg-primary"
}
const _hoisted_29 = { class: "table-responsive" }
const _hoisted_30 = { class: "table align-middle table-row-dashed fs-6 gy-5 mb-0" }
const _hoisted_31 = { class: "text-start text-gray-400 fw-bold fs-7 text-nowrap text-uppercase gs-0" }
const _hoisted_32 = { class: "text-start" }
const _hoisted_33 = { class: "text-start" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "text-start" }, null, -1))
const _hoisted_35 = { class: "text-start" }
const _hoisted_36 = { class: "text-start" }
const _hoisted_37 = { class: "text-end" }
const _hoisted_38 = { class: "text-end" }
const _hoisted_39 = { class: "text-end" }
const _hoisted_40 = { class: "fw-bold text-gray-800" }
const _hoisted_41 = {
  key: 0,
  class: "fs-7 text-gray-400 text-nowrap"
}
const _hoisted_42 = { class: "text-start" }
const _hoisted_43 = { key: 1 }
const _hoisted_44 = { class: "text-end" }
const _hoisted_45 = { class: "text-end" }
const _hoisted_46 = ["title"]
const _hoisted_47 = ["title"]
const _hoisted_48 = ["title"]
const _hoisted_49 = ["title"]
const _hoisted_50 = { class: "text-end" }
const _hoisted_51 = { class: "d-flex align-items-center" }
const _hoisted_52 = {
  key: 0,
  class: "svg-icon svg-icon-3 svg-icon-success ms-1"
}
const _hoisted_53 = { class: "text-end" }
const _hoisted_54 = { class: "d-flex justify-content-end gap-2" }
const _hoisted_55 = ["disabled", "onClick"]
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle" }, null, -1))
const _hoisted_57 = [
  _hoisted_56
]
const _hoisted_58 = { class: "svg-icon svg-icon-3" }
const _hoisted_59 = ["onClick"]
const _hoisted_60 = { class: "svg-icon svg-icon-3" }
const _hoisted_61 = ["onClick"]
const _hoisted_62 = { class: "svg-icon svg-icon-3" }
const _hoisted_63 = ["onClick"]
const _hoisted_64 = { class: "svg-icon svg-icon-3" }
const _hoisted_65 = ["onClick"]
const _hoisted_66 = { class: "svg-icon svg-icon-3" }
const _hoisted_67 = ["onClick"]
const _hoisted_68 = { class: "svg-icon svg-icon-3" }
const _hoisted_69 = { key: 0 }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "7",
  class: "text-center"
}, "No Data", -1))
const _hoisted_71 = [
  _hoisted_70
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_product_info = _resolveComponent("product-info")!
  const _component_sku_info = _resolveComponent("sku-info")!
  const _component_ProductException = _resolveComponent("ProductException")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_InspectionStepsModal = _resolveComponent("InspectionStepsModal")!
  const _component_waiting_approve = _resolveComponent("waiting-approve")!
  const _component_waiting_approve_mismatch = _resolveComponent("waiting-approve-mismatch")!
  const _component_second_time_inspection = _resolveComponent("second-time-inspection")!
  const _component_print_preview = _resolveComponent("print-preview")!
  const _directive_auth = _resolveDirective("auth")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h3", null, _toDisplayString(_ctx.t("inspection.goodsItems")), 1)
        ]),
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_4, [
          (
            _ctx.inspectionFormData.inspection_status <=
              _ctx.InspectionStatus.Inspection &&
            _ctx.inspectionFormData.inspection_date &&
            (_ctx.inspectionStage === _ctx.InspectionStage.FirstTimeInspection ||
              _ctx.inspectionStage === 0)
          )
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "btn btn-sm btn-light-primary",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onQuickInspectionClick && _ctx.onQuickInspectionClick(...args)))
              }, [
                _createElementVNode("span", _hoisted_5, [
                  _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/ecommerce/ecm010.svg" })
                ]),
                _createTextVNode(" " + _toDisplayString(_ctx.t("inspection.quickInspection")), 1)
              ]))
            : _createCommentVNode("", true),
          (
            _ctx.inspectionFormData.inspection_status <=
              _ctx.InspectionStatus.Inspection &&
            _ctx.inspectionFormData.inspection_date &&
            (_ctx.inspectionStage === _ctx.InspectionStage.FirstTimeInspection ||
              _ctx.inspectionStage === 0)
          )
            ? (_openBlock(), _createElementBlock("button", _hoisted_6, [
                _createElementVNode("span", _hoisted_7, [
                  _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/ecommerce/ecm010.svg" })
                ]),
                _createTextVNode(" " + _toDisplayString(_ctx.t("inspection.inspection")), 1)
              ]))
            : _createCommentVNode("", true)
        ])), [
          [_directive_auth, { auth: ['update'] }]
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("ul", _hoisted_9, [
          _createElementVNode("li", _hoisted_10, [
            _createElementVNode("a", {
              href: "#",
              class: _normalizeClass(["nav-link btn btn-outline btn-flex btn-color-muted btn-active-color-primary flex-column overflow-hidden min-w-80px h-95px px-5 pt-5 pb-2 position-relative", { active: _ctx.activeIndex === 0 }]),
              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.onNavTabClick(0, 0)), ["prevent"]))
            }, [
              _createElementVNode("span", _hoisted_11, [
                _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/abstract/abs029.svg" })
              ]),
              _createElementVNode("span", null, _toDisplayString(_ctx.t("inspection.all")), 1),
              (_ctx.activeIndex === 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_12))
                : _createCommentVNode("", true)
            ], 2)
          ]),
          _createElementVNode("li", _hoisted_13, [
            _createElementVNode("a", {
              href: "#",
              class: _normalizeClass(["nav-link btn btn-outline btn-flex btn-color-muted btn-active-color-primary flex-column overflow-hidden min-w-80px h-95px px-5 pt-5 pb-2 position-relative", { active: _ctx.activeIndex === 1 }]),
              onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (
              _ctx.onNavTabClick(1, _ctx.InspectionStage.FirstTimeInspection)
            ), ["prevent"]))
            }, [
              _createElementVNode("span", _hoisted_14, [
                _createVNode(_component_inline_svg_icon, { src: "media/svg/custom/inspection-1st.svg" })
              ]),
              _createElementVNode("span", null, _toDisplayString(_ctx.inspectionStageQty[_ctx.InspectionStage.FirstTimeInspection]), 1),
              _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.t("inspection.firstTimeInspection")), 1),
              (_ctx.activeIndex === 1)
                ? (_openBlock(), _createElementBlock("span", _hoisted_16))
                : _createCommentVNode("", true)
            ], 2)
          ]),
          _createElementVNode("li", _hoisted_17, [
            _createElementVNode("a", {
              href: "#",
              class: _normalizeClass(["nav-link btn btn-outline btn-flex btn-color-muted btn-active-color-primary flex-column overflow-hidden min-w-80px h-95px px-5 pt-5 pb-2 position-relative", { active: _ctx.activeIndex === 2 }]),
              onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (
              _ctx.onNavTabClick(2, _ctx.InspectionStage.SecondTimeInspection)
            ), ["prevent"]))
            }, [
              _createElementVNode("span", _hoisted_18, [
                _createVNode(_component_inline_svg_icon, { src: "media/svg/custom/inspection-2nd.svg" })
              ]),
              _createElementVNode("span", null, _toDisplayString(_ctx.inspectionStageQty[_ctx.InspectionStage.SecondTimeInspection]), 1),
              _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.t("inspection.secondTimeInspection")), 1),
              (_ctx.activeIndex === 2)
                ? (_openBlock(), _createElementBlock("span", _hoisted_20))
                : _createCommentVNode("", true)
            ], 2)
          ]),
          _createElementVNode("li", _hoisted_21, [
            _createElementVNode("a", {
              href: "#",
              class: _normalizeClass(["nav-link btn btn-outline btn-flex btn-color-muted btn-active-color-primary flex-column overflow-hidden min-w-80px h-95px px-5 pt-5 pb-2 position-relative", { active: _ctx.activeIndex === 3 }]),
              onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.onNavTabClick(3, _ctx.InspectionStage.WaitingApprove)), ["prevent"]))
            }, [
              _createElementVNode("span", _hoisted_22, [
                _createVNode(_component_inline_svg_icon, { src: "media/svg/custom/waiting-approve.svg" })
              ]),
              _createElementVNode("span", null, _toDisplayString(_ctx.inspectionStageQty[_ctx.InspectionStage.WaitingApprove]), 1),
              _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.t("inspection.waitingApprove")), 1),
              (_ctx.activeIndex === 3)
                ? (_openBlock(), _createElementBlock("span", _hoisted_24))
                : _createCommentVNode("", true)
            ], 2)
          ]),
          _createElementVNode("li", _hoisted_25, [
            _createElementVNode("a", {
              href: "#",
              class: _normalizeClass(["nav-link btn btn-outline btn-flex btn-color-muted btn-active-color-primary flex-column overflow-hidden min-w-80px h-95px px-5 pt-5 pb-2 position-relative", { active: _ctx.activeIndex === 4 }]),
              onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (
              _ctx.onNavTabClick(4, _ctx.InspectionStage.InspectionFinished)
            ), ["prevent"]))
            }, [
              _createElementVNode("span", _hoisted_26, [
                _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen048.svg" })
              ]),
              _createElementVNode("span", null, _toDisplayString(_ctx.inspectionStageQty[_ctx.InspectionStage.InspectionFinished]), 1),
              _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.t("inspection.inspectionFinished")), 1),
              (_ctx.activeIndex === 4)
                ? (_openBlock(), _createElementBlock("span", _hoisted_28))
                : _createCommentVNode("", true)
            ], 2)
          ])
        ]),
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("table", _hoisted_30, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", _hoisted_31, [
                _createElementVNode("th", _hoisted_32, _toDisplayString(_ctx.t("order.guid")), 1),
                _createElementVNode("th", _hoisted_33, _toDisplayString(_ctx.t("order.article")), 1),
                _hoisted_34,
                _createElementVNode("th", _hoisted_35, _toDisplayString(_ctx.t("inspection.missingInfomation")), 1),
                _createElementVNode("th", _hoisted_36, _toDisplayString(_ctx.t("inspection.type")), 1),
                _createElementVNode("th", _hoisted_37, _toDisplayString(_ctx.t("inspection.stage")), 1),
                _createElementVNode("th", _hoisted_38, _toDisplayString(_ctx.t("inspection.result")), 1),
                _createElementVNode("th", _hoisted_39, _toDisplayString(_ctx.t("common.action")), 1)
              ])
            ]),
            _createElementVNode("tbody", _hoisted_40, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableData, (item, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  _createElementVNode("td", null, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", null, _toDisplayString(item.identifier_code), 1),
                      (item.order_number)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                            _createElementVNode("span", null, _toDisplayString(item.order_number), 1),
                            _createElementVNode("span", null, "#SUB" + _toDisplayString(item.position), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("td", null, [
                    _createVNode(_component_product_info, {
                      gallery: item.gallery,
                      name: item.name_en,
                      name_en: item.name_en,
                      source_link: '',
                      brand_id: item.__show.brand_id
                    }, null, 8, ["gallery", "name", "name_en", "brand_id"])
                  ]),
                  _createElementVNode("td", null, [
                    _createVNode(_component_sku_info, {
                      brand_article_no: item.brand_article_no,
                      color: item.original_color,
                      size: item.__show.size,
                      capacity: item.__show.capacity,
                      product_identifier_id: item.product_identifier_id
                    }, null, 8, ["brand_article_no", "color", "size", "capacity", "product_identifier_id"])
                  ]),
                  _createElementVNode("td", _hoisted_42, [
                    (item.guid_exception.length > 0)
                      ? (_openBlock(), _createBlock(_component_ProductException, {
                          key: 0,
                          class: "mw-150px text-danger",
                          guidException: item.guid_exception
                        }, null, 8, ["guidException"]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_43, "--"))
                  ]),
                  _createElementVNode("td", _hoisted_44, _toDisplayString(item.__show.type), 1),
                  _createElementVNode("td", _hoisted_45, [
                    (
                    item.inspection_stage ===
                    _ctx.InspectionStage.FirstTimeInspection
                  )
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: "svg-icon svg-icon-2 svg-icon-primary",
                          title: _ctx.t('inspection.firstTimeInspection')
                        }, [
                          _createVNode(_component_inline_svg_icon, { src: "media/svg/custom/inspection-1st.svg" })
                        ], 8, _hoisted_46))
                      : (
                    item.inspection_stage ===
                    _ctx.InspectionStage.SecondTimeInspection
                  )
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 1,
                            class: "svg-icon svg-icon-2 svg-icon-primary",
                            title: _ctx.t('inspection.secondTimeInspection')
                          }, [
                            _createVNode(_component_inline_svg_icon, { src: "media/svg/custom/inspection-2nd.svg" })
                          ], 8, _hoisted_47))
                        : (
                    item.inspection_stage === _ctx.InspectionStage.WaitingApprove
                  )
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 2,
                              class: "svg-icon svg-icon-2 svg-icon-primary",
                              title: _ctx.t('inspection.waitingApprove')
                            }, [
                              _createVNode(_component_inline_svg_icon, { src: "media/svg/custom/waiting-approve.svg" })
                            ], 8, _hoisted_48))
                          : (
                    item.inspection_stage === _ctx.InspectionStage.InspectionFinished
                  )
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 3,
                                class: "svg-icon svg-icon-2 svg-icon-success",
                                title: _ctx.t('inspection.inspectionFinished')
                              }, [
                                _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen048.svg" })
                              ], 8, _hoisted_49))
                            : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("td", _hoisted_50, [
                    _createElementVNode("div", _hoisted_51, [
                      _createElementVNode("span", {
                        class: _normalizeClass({
                      'text-success':
                        item.inspection_result === _ctx.InspectionResult.Passed,
                    })
                      }, _toDisplayString(item.__show.inspection_result), 3),
                      (
                      item.inspection_result === _ctx.InspectionResult.Passed &&
                      item.image_quantity > 0
                    )
                        ? (_openBlock(), _createElementBlock("span", _hoisted_52, [
                            _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/general/gen006.svg" })
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_53, [
                    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_54, [
                      (item.match_status !== 30)
                        ? (_openBlock(), _createBlock(_component_el_popover, {
                            key: 0,
                            placement: "top",
                            width: "auto",
                            trigger: "hover"
                          }, {
                            reference: _withCtx(() => [
                              (item.match_status !== 30)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    type: "button",
                                    class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm",
                                    disabled: item.printDisabled,
                                    onClick: ($event: any) => (_ctx.getPrintedSheet(item))
                                  }, [
                                    _withDirectives(_createElementVNode("span", null, _hoisted_57, 512), [
                                      [_vShow, item.printDisabled]
                                    ]),
                                    _withDirectives(_createElementVNode("span", _hoisted_58, [
                                      _createVNode(_component_inline_svg_icon, { src: "media/svg/custom/print.svg" })
                                    ], 512), [
                                      [_vShow, !item.printDisabled]
                                    ])
                                  ], 8, _hoisted_55))
                                : _createCommentVNode("", true)
                            ]),
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.t("inspection.printStockInLabel")) + " ", 1)
                            ]),
                            _: 2
                          }, 1024))
                        : _createCommentVNode("", true),
                      (
                      item.inspection_stage ===
                      _ctx.InspectionStage.FirstTimeInspection
                    )
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            type: "button",
                            class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm",
                            "data-bs-toggle": "modal",
                            "data-bs-target": "#modal_inspection_steps",
                            onClick: ($event: any) => (_ctx.editInspection(item))
                          }, [
                            _createElementVNode("span", _hoisted_60, [
                              _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/art/art005.svg" })
                            ])
                          ], 8, _hoisted_59))
                        : (
                      item.inspection_stage ===
                      _ctx.InspectionStage.SecondTimeInspection
                    )
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 2,
                              type: "button",
                              class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm",
                              "data-bs-toggle": "modal",
                              "data-bs-target": "#modal_second_time_inspection",
                              onClick: ($event: any) => (_ctx.editInspection(item))
                            }, [
                              _createElementVNode("span", _hoisted_62, [
                                _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/art/art005.svg" })
                              ])
                            ], 8, _hoisted_61))
                          : (
                      item.inspection_stage ===
                        _ctx.InspectionStage.WaitingApprove &&
                      item.match_status == 20
                    )
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 3,
                                type: "button",
                                class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm",
                                "data-bs-toggle": "modal",
                                "data-bs-target": "#modal_waiting_approve_mismatch",
                                onClick: ($event: any) => (_ctx.editInspection(item))
                              }, [
                                _createElementVNode("span", _hoisted_64, [
                                  _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/art/art005.svg" })
                                ])
                              ], 8, _hoisted_63))
                            : (
                      item.inspection_stage ===
                        _ctx.InspectionStage.WaitingApprove &&
                      item.match_status != 20
                    )
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 4,
                                  type: "button",
                                  class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm",
                                  "data-bs-toggle": "modal",
                                  "data-bs-target": "#modal_waiting_approve",
                                  onClick: ($event: any) => (_ctx.editInspection(item))
                                }, [
                                  _createElementVNode("span", _hoisted_66, [
                                    _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/art/art005.svg" })
                                  ])
                                ], 8, _hoisted_65))
                              : (item.inspection_result != 0)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 5,
                                    type: "button",
                                    class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm",
                                    "data-bs-toggle": "modal",
                                    "data-bs-target": "#modal_waiting_approve",
                                    onClick: ($event: any) => (_ctx.editInspection(item))
                                  }, [
                                    _createElementVNode("span", _hoisted_68, [
                                      _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/art/art005.svg" })
                                    ])
                                  ], 8, _hoisted_67))
                                : _createCommentVNode("", true)
                    ])), [
                      [_directive_auth, { auth: ['update'] }]
                    ])
                  ])
                ]))
              }), 128)),
              (_ctx.tableData.length == 0)
                ? (_openBlock(), _createElementBlock("tr", _hoisted_69, _hoisted_71))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ])), [
      [_directive_loading, _ctx.loading]
    ]),
    _createVNode(_component_InspectionStepsModal, {
      tableData: _ctx.tableData,
      itemData: _ctx.inspectionDetailInspectionData,
      identifierCode: _ctx.inspectionDetailInspectionData.identifier_code,
      onUpdateList: _ctx.getFromInfo,
      onUpdateDetail: _ctx.updateDetail,
      onResetForm: _ctx.resetInspection,
      onPrintPreview: _ctx.printPreviewProduct
    }, null, 8, ["tableData", "itemData", "identifierCode", "onUpdateList", "onUpdateDetail", "onResetForm", "onPrintPreview"]),
    _createVNode(_component_waiting_approve, {
      itemData: _ctx.inspectionDetailInspectionData,
      onUpdateList: _ctx.getFromInfo,
      onUpdateDetail: _ctx.updateDetail,
      onResetForm: _ctx.resetInspection
    }, null, 8, ["itemData", "onUpdateList", "onUpdateDetail", "onResetForm"]),
    _createVNode(_component_waiting_approve_mismatch, {
      itemData: _ctx.inspectionDetailInspectionData,
      onUpdateList: _ctx.getFromInfo,
      onUpdateDetail: _ctx.updateDetail,
      onResetForm: _ctx.resetInspection
    }, null, 8, ["itemData", "onUpdateList", "onUpdateDetail", "onResetForm"]),
    _createVNode(_component_second_time_inspection, {
      itemData: _ctx.inspectionDetailInspectionData,
      onUpdateList: _ctx.getFromInfo,
      onResetForm: _ctx.resetInspection
    }, null, 8, ["itemData", "onUpdateList", "onResetForm"]),
    _createVNode(_component_print_preview, { ref: "printPreviewRef" }, null, 512)
  ], 64))
}